export enum AddressType {
  Main = 'MAIN',
  Contact = 'CONTACT',
  ShipTo = 'SHIP_TO',
  BillTo = 'BILL_TO',
  ShipFrom = 'SHIP_FROM',
  BillFrom = 'BILL_FROM',
  ReturnTo = 'RETURN_TO',
  Dba = 'DBA',
  Other = 'OTHER',
  Warehouse = 'WAREHOUSE'
}